import "@perxis-auto/shared";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import "@perxis-auto/shared/lib";
import { formatVehicleStatus } from "../../../shared/lib/format/vehicle/formatVehicleStatus.js";
import "../../../shared/lib/logger/index.js";
const GET_DEFAULT_CONTAINER_PROPS = () => ({
  formatVehicleStatus
});
export {
  GET_DEFAULT_CONTAINER_PROPS
};
